module.exports = __webpack_public_path__ + "img/img-web-subsidio-nacimiento.a19c3c60.jpg";